'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_OWNERSHIP = exports.TOGGLE_I_OWN_THIS = exports.SHELVES = undefined;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHELVES = exports.SHELVES = _constantsAnalytics2.default.CATEGORIES.SHELVES;
var TOGGLE_I_OWN_THIS = exports.TOGGLE_I_OWN_THIS = _constantsAnalytics2.default.EVENTS.TOGGLE_I_OWN_THIS;
var TOGGLE_OWNERSHIP = exports.TOGGLE_OWNERSHIP = _constantsAnalytics2.default.ACTIONS.TOGGLE_OWNERSHIP;

function composeIOwnThisEvent(iOwnThisStatus) {
  return (0, _compose.composeEvent)(TOGGLE_I_OWN_THIS, {
    gtmValue: 1,
    gtmLabel: iOwnThisStatus,
    gtmCategory: SHELVES,
    gtmAction: TOGGLE_OWNERSHIP
  });
}

function composeToggleIOwnThisEvent(iOwnThisStatus) {
  // conversion made because gtmLabel is expecting a string
  var status = iOwnThisStatus ? 'true' : 'false';
  return (0, _compose.composeAnalytics)([composeIOwnThisEvent(status)]);
}

exports.default = {
  composeToggleIOwnThisEvent: composeToggleIOwnThisEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/iOwnThisEventComposer.js
// module id = 582
// module chunks = 0 2 4 5 6 8 9 10 11